
import { Component, Vue, Watch,Prop } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import { ProductInfo } from "@/model/HqPackingListModels";
import { savePackingInfo } from "@/api/closing-order";
import {
  CustomsPackingModel,
  HqPackingListModel, HqPackingListState,
  LoadingInfo,
  PackingVolume,
  PackingWeight,
  SecondaryPackingModel
} from "@/model/HenganLoadingPlanModels";
import {
  getHqPackingListsPackages
} from "@/api/hq-packing-list";
import {checkPacking} from "@/api/hengan-loading-plan";
import Template from "@/views/system-management/template/index.vue";
@Component({
  name: "EditPlan",
  components: {
    Template,
    Pagination
  }
})
export default class extends Vue{
  @Prop({ default: false }) private updateHenganLoadingPlanDialogVisible: boolean;
  @Prop({ default: {} }) private packingInfoRequest: {};
  @Prop({ default: [] }) private customsPackingTableData: any;
  @Prop({ default: '' }) private id: '';
  @Prop({ default: '' }) private state: '';
  @Prop({ default: [] }) private selectedHqPackingListIds: [];
  @Prop({ default: [] }) private codeList: [];
  private customsPackingSet: CustomsPackingModel[] = [];
  private createHenganLoadingPlanRequest: CreateHenganLoadingPlanRequest =
    new CreateHenganLoadingPlanRequest();
  private data: PackingInfo[] = [];
  private checkedAll = false;
  private close() {
    this.$emit("update:updateHenganLoadingPlanDialogVisible", false);
  }
  private open() {
    this.$emit("update:updateHenganLoadingPlanDialogVisible", true);
  }
  private gotoEditPage(item) {
    console.log(item)
  }
  private getSummaries(params) {
    const {columns, data} = params;
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = "合计:\n" + data.reduce((pre) => {
            return pre + 1;
        }, 0);
      }
      if (index === 1) {
        sums[index] = "CTN:\n" + data.reduce((pre, cur) => {
          if (!cur.packingCode.includes("次包装") &&
              !cur.packingCode.includes("产品") &&
              cur.packingCode.includes("CTN")){
            return pre + 1;
          }else {
            return pre;
          }
        }, 0);
      }
      if (index === 2) {
        sums[index] = "PLT:\n" + data.reduce((pre, cur) => {
          if (!cur.packingCode.includes("次包装") &&
              !cur.packingCode.includes("产品") &&
              cur.packingCode.includes("PLT")){
            return pre + 1;
          }else {
            return pre;
          }
        }, 0);
      }
      if (index === 3) {
        sums[index] = "次包装:\n" + data.reduce((pre, cur) => {
          if (cur.packingCode.includes("次包装")){
            return pre + 1;
          }else {
            return pre;
          }
        }, 0);
      }
      if (index === 4) {
        sums[index] = "产品:\n" + data.reduce((pre, cur) => {
          if (cur.packingCode.includes("产品")){
            return pre + 1;
          }else {
            return pre;
          }
        }, 0);
      }
      if (index === 5) {
        sums[index] = "体积:\n" + data.reduce((pre, cur) => {
          return pre + Number(cur.volume);
        }, 0).toFixed(2);
      }
      if (index === 6) {
        sums[index] = "数量:\n" + data.reduce((pre, cur) => {
          return pre + Number(cur.totalProductQuantity);
        }, 0);
      }
      if (index === 7) {
        sums[index] = "价格:\n" + data.reduce((pre, cur) => {
          return pre + Number(cur.totalPrice);
        }, 0).toFixed(2);
      }
      if (index === 8) {

      }
    });
    return sums;
  }
  private async resetPackingInfos() {
    this.data = [];
    await this.searchCustomsPacking();
  }
  private deleteCatalogProduct(packingId: string) {
    this.data = this.data.filter(d => d.packingId !== packingId);
    this.createHenganLoadingPlanRequest.packingInfos = this.data;
    this.searchCustomsPacking();
  }
  private async doUpdateHenganLoadingPlan() {
    this.createHenganLoadingPlanRequest.packingInfos = this.data;
    let postData = {
      packingInfos: this.data.map(ex => {return ex}),
      id: this.id
    }
    console.log('this.data',this.data)
    await savePackingInfo(postData).then((res) => {
      this.updateHenganLoadingPlanDialogVisible = false;
      this.data = [];
      this.$notify({
        title: "Success",
        message: "更新成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit('closeInit')
    });
  }
  private defSubmit() {
    this.close();
    this.$emit('closeInit')
  }
  private searchCustomsPacking() {
    getHqPackingListsPackages({
      ids: this.selectedHqPackingListIds.join(","),
    }).then((res: any) => {
      let hqPackingLists: HqPackingListModel[] = res.map(
        (value) => value.hqPackingList
      );
      this.customsPackingSet = hqPackingLists
        .map((value) => value.customsPackingSet)
        .reduce((pre, cur) => pre.concat(cur), []);
      let customsPackingTableData = hqPackingLists
        .map((hqPackingList) =>
          hqPackingList.customsPackingSet.map(
            (value) =>
              new CustomsPackingTableRowData(
                hqPackingList.deliveryNoteId,
                hqPackingList.id,
                hqPackingList.deliveryNoteCode,
                hqPackingList.code,
                hqPackingList.state,
                hqPackingList.factoryName,
                value
              )
          )
        )
        .reduce((pre, cur) => pre.concat(cur), []);
      this.getNewList(customsPackingTableData);
    });
  }
  private getNewList(customsPackingTableData: any) {
    let customsPackingIds = this.data.filter(v => v.packingType==="C").map(c => c.packingId);
    let secondaryIds = this.data.filter(v => v.packingType==="S").map(c => c.packingId);
    let productIds = this.data.filter(v => v.packingType==="P").map(c => c.packingId);
    // 排除已分配的主包装
    this.customsPackingTableData = customsPackingTableData.filter(c => !(customsPackingIds.indexOf(c.id) > -1));
    for (let i = 0; i < this.customsPackingTableData.length; i++) {
      let secondaryPackingTableRowData = this.customsPackingTableData[i].secondaryRows.filter(s => !(secondaryIds.indexOf(s.id) > -1));
      // 排除已分配的次包装
      for (let j = 0; j < secondaryPackingTableRowData.length; j++) {
        let product = secondaryPackingTableRowData[j].productRows;
        // 排除已分配的产品
        secondaryPackingTableRowData[j].productRows = product.filter(p => !(productIds.indexOf(p.id) > -1));
      }
      this.customsPackingTableData[i].secondaryRows = secondaryPackingTableRowData;
    }
  }
  // private checkedAllSelect() {
  //   console.log(111)
  // }
  private checkedAllSelect() {
    if (!this.checkedAll) {
      this.$nextTick(() => {
        this.customsPackingTableData.forEach((row) => {
          this.$set(row, "selected", false);
          this.onCustomsRowSelect(row);
        });
      });
      return
    }
    this.toggleSelection(this.customsPackingTableData);
  }
  private toggleSelection(rows) {
    if (rows) {
      this.$nextTick(() => {
        rows.forEach((row) => {
          if(row.inventory !== 'MIX'
              && row.purchaseOrderExceptionsProcessed === true
              && !row.exception) { // 全选不选择混装和采购订单存在超欠发情况的。
            this.$set(row, "selected", true);
          }
          this.onCustomsRowSelect(row);
        });
      });
    }
  }
  private filterHandler(value, row) {
    return row.factoryName === value;
  }
  private onCustomsRowSelect(row) {
    row.indeterminate = false;
    this.toggleChildrenCheckboxInCustomsPacking([row], row.selected);
  }
  private toggleChildrenCheckboxInCustomsPacking(
    rows,
    select: boolean
  ) {
    rows.map((row) => {
      row.secondaryRows.map((secondRow) => {
        secondRow.selected = select;
        this.toggleChildrenCheckboxInSecondaryPacking(
          secondRow.productRows,
          select
        );
      });
    });
  }
  private toggleChildrenCheckboxInSecondaryPacking(
    rows,
    select: boolean
  ) {
    rows.map((row) => {
      row.selected = select;
    });
  }
  private searchHqPackingList() {
    console.log(111)
    // if (!this.createHenganLoadingPlanRequest.customerId) {
    //   Message.error({
    //     message: "请选择客户",
    //     duration: 2000,
    //   });
    //   return;
    // }
    // if (!this.createHenganLoadingPlanRequest.companyCode) {
    //   Message.error({
    //     message: "请选择公司",
    //     duration: 2000,
    //   });
    //   return;
    // }
    // searchCustomerHqPackingList(
    //   this.createHenganLoadingPlanRequest.customerId,
    //   { companyCode: this.createHenganLoadingPlanRequest.companyCode }
    // ).then((res: any) => (this.cascaderOptions = res));
  }
  // private onCustomsRowSelect() {
  //   console.log(111)
  // }
  private onSecondaryRowSelect(row) {
    row.indeterminate = false;
    this.toggleChildrenCheckboxInSecondaryPacking(
      row.productRows,
      row.selected
    );
    this.toggleParentCheckboxBySecondaryPackingRow(row);
  }
  private toggleParentCheckboxBySecondaryPackingRow(row) {
    const parent: CustomsPackingTableRowData =
      this.customsPackingTableData.filter((value) => value.id === row.pid)[0];
    parent.updateSelectState();
  }
  private onProductRowSelect(row) {
    this.toggleParentCheckboxByProductRow(row);
  }
  private toggleParentCheckboxByProductRow(productRow) {
    for (let i = 0; i < this.customsPackingTableData.length; i++) {
      for (
        let j = 0;
        j < this.customsPackingTableData[i].secondaryRows.length;
        j++
      ) {
        if (
          this.customsPackingTableData[i].secondaryRows[j].id === productRow.pid
        ) {
          let secondaryPackingRows: SecondaryPackingTableRowData[] =
            this.customsPackingTableData[i].secondaryRows;
          secondaryPackingRows.map((value) => value.updateSelectState());
          this.customsPackingTableData[i].updateSelectState();
          return;
        }
      }
    }
  }
  private canChange(row: any) {
    return !((row.hqPackingListState.name === 'IN_STORAGE' || row.hqPackingListState.name === 'PART_OF_OUTBOUND') && (!row.inventory || row.inventory === 'NO'));
  }
  private onSelectedProductQuantityChange() {
    console.log(111)
  }
  private  addPackingLoading = false;
  public async doAddHenganLoadingPlan() {
    this.addPackingLoading = true;
    const packingInfos: PackingInfo[] = [];
    for (let i = 0; i < this.customsPackingTableData.length; i++) {
      const customsRow = this.customsPackingTableData[i];
      if (customsRow.selected) {
        packingInfos.push(
          new PackingInfo(customsRow.id, "C", 0,
            customsRow.loadingFirst,
            customsRow.displayCode,
            customsRow.declarationDescriptions,
            customsRow.volume,
            customsRow.purchaseOrderNumbers,
            customsRow.factoryName,
            customsRow.totalProductQuantity,
            customsRow.totalPrice,
            customsRow.hqPackingListCode,
            customsRow.deliveryNoteCode,
            customsRow.hqPackingListId,
            customsRow.deliveryNoteId,
            false
          )
        );
      } else {
        for (let j = 0; j < customsRow.secondaryRows.length; j++) {
          const secondaryRow: SecondaryPackingTableRowData =
            customsRow.secondaryRows[j];
          if (secondaryRow.selected) {
            packingInfos.push(
              new PackingInfo(
                secondaryRow.id,
                "S",
                0,
                secondaryRow.loadingFirst,
                "次包装\n" + customsRow.displayCode,
                secondaryRow.declarationDescriptions,
                secondaryRow.volume,
                secondaryRow.purchaseOrderNumbers,
                secondaryRow.factoryName,
                secondaryRow.totalProductQuantity,
                secondaryRow.totalPrice,
                customsRow.hqPackingListCode,
                customsRow.deliveryNoteCode,
                customsRow.hqPackingListId,
                customsRow.deliveryNoteId,
                false
              )
            );
          } else {
            for (let k = 0;k < secondaryRow.productRows.length; k++) {
              const productRow = secondaryRow.productRows[k];
              if (productRow.selected) {
                packingInfos.push(new PackingInfo(
                  productRow.id,
                  "P",
                  productRow.quantity,
                  productRow.loadingFirst,
                  "产品\n" + customsRow.displayCode,
                  productRow.declarationDescription,
                  "0.00",
                  productRow.purchaseOrderNumber,
                  customsRow.factoryName,
                  productRow.quantity,
                  productRow.unitPrice.toFixed(2),
                  customsRow.hqPackingListCode,
                  customsRow.deliveryNoteCode,
                  customsRow.hqPackingListId,
                  customsRow.deliveryNoteId,
                  false
                ));
              }
            }
          }
        }
      }
    }
    console.log('packingInfos',packingInfos)
    try {
      await checkPacking(packingInfos.filter(item => item?.packingId != null).map(item => item.packingId));
      this.data.push(...packingInfos);
      this.createHenganLoadingPlanRequest.packingInfos = this.data;
      this.searchCustomsPacking();
      this.checkedAll = false;
    }catch (error) {
      console.error(error);
    } finally {
      this.addPackingLoading = false;
    }
  }
  private seleteAllUnpacking() {
    console.log(111)
  }
  private seleteAllLoadingFirst() {
    console.log(111)
  }
  private removePackingInfos() {
    this.data = [];
    this.createHenganLoadingPlanRequest.packingInfos = this.data;
    this.searchCustomsPacking();
  }
  private getFactoryNameFilters() {
    console.log(111)
  }
}
class CustomsPackingTableRowData {
  id: string;
  deliveryNoteId: string;
  hqPackingListId: string;
  deliveryNoteCode: string;
  hqPackingListCode: string;
  hqPackingListState: HqPackingListState;
  factoryName: string;
  displayCode: string;
  volume: string;
  grossWeight: string;
  netWeight: string;
  selected: boolean;
  loadingFirst: boolean;
  indeterminate: boolean;
  totalPrice: string;
  descriptions: string;
  declarationDescriptions: string;
  purchaseOrderNumbers: string;
  totalProductQuantity: number;
  inventory: string;
  secondaryRows: SecondaryPackingTableRowData[] = [];
  purchaseOrderExceptionsProcessed: boolean;
  exception: boolean;
  exceptionReason: CustomsPackingProblemType;


  constructor(
    deliveryNoteId: string,
    hqPackingListId: string,
    deliveryNoteCode: string,
    hqPackingListCode: string,
    hqPackingListState: HqPackingListState,
    factoryName: string,
    customsPacking: CustomsPackingModel
  ) {
    this.deliveryNoteId = deliveryNoteId;
    this.hqPackingListId = hqPackingListId;
    this.deliveryNoteCode = deliveryNoteCode;
    this.hqPackingListCode = hqPackingListCode;
    this.hqPackingListState = hqPackingListState;
    this.factoryName = factoryName;
    if (customsPacking) {
      this.id = customsPacking.id;
      this.volume = this.calculateVolume(customsPacking.packingVolume);
      this.grossWeight = String(customsPacking.packingWeight?.grossWeight);
      this.netWeight = String(customsPacking.packingWeight?.netWeight);
      this.inventory = customsPacking.inventory;
      this.purchaseOrderExceptionsProcessed = customsPacking.purchaseOrderExceptionsProcessed;
      this.exception = customsPacking.exception;
      this.exceptionReason = customsPacking.exceptionReason;
      this.displayCode =
        customsPacking.code.typeCode +
        customsPacking.code.selfCode +
        "#" +
        customsPacking.code.serialNumber;
      this.secondaryRows = customsPacking.secondaryPackingSet?.map(
        (value) =>
          new SecondaryPackingTableRowData(
            customsPacking.id,
            factoryName,
            value,
            hqPackingListState,
            this.inventory
          )
      );
      this.totalPrice = this.secondaryRows
        ?.map((value) => value.totalPrice)
        .reduce((pre, cur) => pre + Number(cur), 0)
        .toFixed(2);
      this.descriptions = this.unique(this.secondaryRows
        ?.map((value) => value.descriptions))
        .join(",");
      this.declarationDescriptions = this.unique(this.secondaryRows
        ?.map((value) => value.declarationDescriptions))
        .join(",");
      this.purchaseOrderNumbers = this.unique(this.secondaryRows
        ?.map((value) => value.purchaseOrderNumbers))
        .join(",");
      this.totalProductQuantity = this.secondaryRows
        ?.map((value) => value.totalProductQuantity)
        .reduce((pre, cur) => pre + Number(cur), 0);
    }
    this.selected = false;
    this.loadingFirst = false;
    this.indeterminate = false;
  }

  unique(arr) {
    return Array.from(new Set(arr));
  }

  calculateVolume(packingVolume: PackingVolume): string {
    return new PackingVolume(
      packingVolume.length,
      packingVolume.width,
      packingVolume.height
    ).calculateVolume();
  }

  updateSelectState() {
    const childrenCount: number = this.secondaryRows.length;
    const childrenSelectedCount: number = this.secondaryRows.filter(
      (value) => value.selected
    ).length;
    const childrenIndeterminateCount: number = this.secondaryRows.filter(
      (value) => value.indeterminate
    ).length;
    this.selected = childrenSelectedCount === childrenCount;
    this.indeterminate =
      (!this.selected && childrenSelectedCount > 0) ||
      childrenIndeterminateCount > 0;
  }

  updateLoadingFirst(value: boolean) {
    this.loadingFirst = value;
  }
}
class ProductTableRowData extends ProductInfo {
  pid: string;
  quantity = 0;
  selected = false;
  loadingFirst = false;
}
class SecondaryPackingTableRowData extends CustomsPackingTableRowData {
  // id: string;
  pid: string;
  cartonNumber: number;
  hqPackingListState: HqPackingListState;
  productRows: ProductTableRowData[] = [];
  inventory: string;

  constructor(
    pid: string,
    factoryName: string,
    secondaryPacking: SecondaryPackingModel,
    hqPackingListState: HqPackingListState,
    inventory: string
  ) {
    super(null, null,null, null, null ,factoryName, null);
    this.id = secondaryPacking.id;
    this.pid = pid;
    this.cartonNumber = secondaryPacking.cartonNumber;
    this.factoryName = factoryName;
    this.hqPackingListState = hqPackingListState;
    const packingWeights: PackingWeight[] = secondaryPacking.packingInfos
      .map((value) => value.packingWeight)
      .reduce((pre, cur) => pre.concat(cur), []);
    this.netWeight = packingWeights
      .map((value) => value.netWeight)
      .reduce((pre, cur) => pre + Number(cur), 0)
      .toFixed(2);
    this.grossWeight = packingWeights
      .map((value) => value.grossWeight)
      .reduce((pre, cur) => pre + Number(cur), 0)
      .toFixed(2);
    // this.netWeight = secondaryPacking.packingInfoRequest.map(value => value.netWeight).reduce((pre, cur) => pre + Number(cur), 0).toFixed(2);
    // this.grossWeight = secondaryPacking.packingInfoRequest.map(value => value.grossWeightPerCarton).reduce((pre, cur) => pre + Number(cur), 0).toFixed(2);
    this.volume = secondaryPacking.packingInfos
      .map((value) => this.calculateVolume(value.packingVolume))
      .reduce((pre, cur) => pre + Number(cur), 0)
      .toFixed(2);
    // const productInfos = secondaryPacking.productInfos;
    const productInfos = secondaryPacking.packingInfos
      .map((value) => value.productInfos)
      .reduce((pre, cur) => pre.concat(cur), []);
    this.totalPrice = productInfos
      .map((value) => value.unitPrice * value.totalNumberPcs)
      .reduce((pre, cur) => pre + Number(cur), 0)
      .toFixed(2);
    this.descriptions = super.unique(productInfos
      .map((value) => value.description))
      .join(",");
    this.declarationDescriptions = super.unique(productInfos
      .map((value) => value.declarationDescription))
      .join(",");
    this.purchaseOrderNumbers = super.unique(productInfos
      .map((value) => value.purchaseOrderNumber))
      .join(",");
    this.totalProductQuantity = productInfos
      .map((value) => value.totalNumberPcs)
      .reduce((pre, cur) => pre + Number(cur), 0);
    this.inventory = inventory;
    this.productRows = productInfos.map((value) => {
      return {
        pid: secondaryPacking.id,
        quantity: value.totalNumberPcs,
        selected: false,
        loadingFirst: false,
        hqPackingListState: hqPackingListState,
        ...value,
      };
    });
  }

  private getRowStyle({row}) {
    return row.loadingFirst ? 'success-row':'';
  }

  updateSelectState() {
    const childrenCount: number = this.productRows.length;
    const childrenSelectedCount: number = this.productRows.filter(
      (value) => value.selected
    ).length;
    this.selected = childrenSelectedCount === childrenCount;
    if (childrenSelectedCount === childrenCount) {
      const childrenSelectedProductQuantity: number = this.productRows
        .filter((value) => value.selected)
        .map((value) => value.quantity)
        .reduce((pre, cur) => pre + Number(cur), 0);
      this.selected =
        this.totalProductQuantity === childrenSelectedProductQuantity;
      this.indeterminate = true;
    } else {
      this.selected = false;
      this.indeterminate = false;
    }
    this.indeterminate = !this.selected && childrenSelectedCount > 0;
  }
}
class PackingInfo {
  id: string;
  henganLoadingPlanId: string;
  packingId: string;
  packingType: string;
  quantity: number;
  loadingFirst: boolean;
  packingCode: string;
  declarationDescriptions: string;
  volume: number;
  purchaseOrderNumbers: string;
  factoryName: string;
  totalProductQuantity: number;
  totalPrice: string;
  hqPackingListCode: string;
  deliveryNoteCode: string;
  deliveryNoteId: string;
  hqPackingListId: string;
  unboxing: boolean;

  constructor(
    packingId: string,
    packingType: string,
    quantity: number,
    loadingFirst: boolean,
    packingCode: string,
    declarationDescriptions: string,
    volume: string,
    purchaseOrderNumbers: string,
    factoryName: string,
    totalProductQuantity: number,
    totalPrice: string,
    hqPackingListCode: string,
    deliveryNoteCode: string,
    hqPackingListId: string,
    deliveryNoteId: string,
    unboxing: boolean
  ) {
    this.packingId = packingId;
    this.packingType = packingType;
    this.quantity = quantity;
    this.loadingFirst = loadingFirst;
    this.packingCode = packingCode;
    this.declarationDescriptions = declarationDescriptions;
    this.volume = parseFloat(volume);
    this.purchaseOrderNumbers = purchaseOrderNumbers;
    this.factoryName = factoryName;
    this.totalProductQuantity = totalProductQuantity;
    this.totalPrice = totalPrice;
    this.hqPackingListCode = hqPackingListCode;
    this.deliveryNoteCode = deliveryNoteCode;
    this.hqPackingListId = hqPackingListId;
    this.deliveryNoteId = deliveryNoteId;
    this.unboxing = unboxing;
  }
}
class CreateHenganLoadingPlanRequest {
  customerId: string;
  companyCode: string;
  shippingOrderId: string;
  transshipDelivery: boolean;
  transshipDeclaration: boolean;
  logisticsSpecialistId: string;
  remark: string;
  referencePackingData: boolean;
  packingInfos: PackingInfo[];
}
class CustomsPackingProblemType {
  name: string;
  value: string;
}
